import { useState } from 'react';
import { ConfigProvider, Layout, Tabs, Button, Typography, theme } from 'antd';
import { TeamOutlined, LogoutOutlined } from '@ant-design/icons';
import keycloak from './keycloak';
import deDE from 'antd/locale/de_DE';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import InvoicesTab from './components/InvoicesTab';
import ReportsTab from './components/ReportsTab';
import ContactsModal from './components/ContactsModal';
import Logo from './components/Logo';
import './App.css';

dayjs.locale('de');

const { Header, Content } = Layout;
const { Title } = Typography;

export default function App() {
  const [contactsOpen, setContactsOpen] = useState(false);

  const tabs = [
    { key: 'incoming', label: 'Eingangsrechnungen', children: <InvoicesTab invoiceType="incoming" /> },
    { key: 'outgoing', label: 'Ausgangsrechnungen', children: <InvoicesTab invoiceType="outgoing" /> },
    { key: 'reports', label: 'Auswertungen', children: <ReportsTab /> },
  ];

  return (
    <ConfigProvider
      locale={deDE}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
        },
      }}
    >
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Logo size={36} />
            <Title level={4} style={{ color: '#fff', margin: 0 }}>Fair Finance</Title>
          </div>
          <Button
            ghost
            icon={<TeamOutlined />}
            onClick={() => setContactsOpen(true)}
          >
            Kontakte
          </Button>
          <Button
            ghost
            icon={<LogoutOutlined />}
            onClick={() => keycloak.logout()}
          >
            Abmelden
          </Button>
        </Header>
        <Content style={{ padding: '24px', maxWidth: 1400, margin: '0 auto', width: '100%' }}>
          <Tabs
            defaultActiveKey="incoming"
            items={tabs}
            size="large"
            style={{ background: '#fff', borderRadius: 8, padding: '0 16px 16px' }}
          />
        </Content>
      </Layout>

      <ContactsModal open={contactsOpen} onClose={() => setContactsOpen(false)} />
    </ConfigProvider>
  );
}
